<template>
  <b-card class="cardStyle h-100">
    <p class="m-0 title">
      <b-icon icon="globe" scale="1.3"></b-icon>&nbsp; &nbsp; Study Enrollment
    </p>
    <div v-if="loading" id="loading" class="text-center my-5 py-5">
      <b-spinner class="align-middle" label="Spinning" type="grow"></b-spinner>
    </div>
    <section v-if="!loading && showStudyEnrollment">
      <b-progress :max="max" class="mb-2 mt-4" height="2rem" show-progress>
        <div
          v-if="!showTargetInfo"
          class="text-center progressBarInfo"
          style="font-size: 12px;background:#e9ecef"
        >
          <strong>There is no planned data available for this study</strong>
        </div>
        <div v-if="showTargetInfo && value === 0" class="progressBarInfo" style="font-size: 14px">
          <strong> 0/ {{ max }}</strong>
        </div>
        <b-progress-bar :style="progressColor" :value="value" v-if="showTargetInfo">
          <div v-if="value > 0" style="font-size: 14px">
            <strong> {{ ((value / max) * 100).toFixed(2) }} %</strong>
          </div>
        </b-progress-bar>
      </b-progress>
      <section class="m-0 mt-3">
        <b-row class="m-0">
          <b-col class="text-left p-0 pl-2" cols="5">
            <div class="m-0 mt-3 textStyle">
              <strong>{{ enrollmentData[0]['label'] }}</strong
              ><span class="m-0 mb-2 info-text-style" v-if="showTargetInfo">
                (Current/Planned)
              </span>
            </div>
          </b-col>
          <b-col class="info-number-style text-right p-0 pl-2 text-nowrap" cols="7"
            ><p class="px-2 mt-3">
              <span style="color: #01004e"> {{ enrollmentData[0].randomized }}</span>
              <span style="color: #6f6f6f" v-if="showTargetInfo"
                >/{{ enrollmentData[0].target }}</span
              >
            </p></b-col
          >
        </b-row>
        <hr class="solid my-3" style="width: 100%" />
        <b-row class="m-0 mt-2">
          <b-col class="text-left p-0 pl-2" cols="5">
            <p class="m-0 mb-2 textStyle">
              {{ enrollmentData[1]['label'] }}
            </p>
          </b-col>
          <b-col class="info-number-style text-right p-0 pl-2" cols="7"
            ><p class="px-2 mt-3">
              <span style="color: #01004e"> {{ enrollmentData[1]['randomized'] }}</span>
            </p></b-col
          >
        </b-row>
      </section>
      <section class="text-right" style="position: absolute; bottom: 10px; width: 90%">
        <b-button class="mt-2" pill variant="link" @click="redirectToEnrollment()"
          >Enrollment
        </b-button>
      </section>
    </section>
    <section v-if="!loading && !showStudyEnrollment" class="noDataTextStyle px-4">
      <p>
        The Enrollment details will be reflected once your Site is Activated and started patient
        enrollment
      </p>
    </section>
  </b-card>
</template>

<script>
  export default {
    name: 'StudyEnrollmentProgress',
    props: {
      studyId: {
        type: String,
      },
      siteId: {
        type: String,
      },
    },
    data() {
      return {
        loading: false,
        max: 1,
        value: 1,
        enrollmentData: [],
        showStudyEnrollment: false,
      };
    },
    computed: {
      isEnrollmentOversight() {
        return this.$route.name.includes('oversight');
      },
      progressColor() {
        return this.enrollmentData.length > 0
          ? 'background: linear-gradient(270deg, #0000C9 0%, rgba(64, 64, 215, 0.54) 100%);opacity:0.6; '
          : 'background:#e9ecef';
      },
      showTargetInfo() {
        if (!this.enrollmentData[0]['target']) {
          return false;
        }
        if (this.enrollmentData[0]['target'] < 2) {
          return false;
        }
        return true;
      },
    },
    created() {
      this.getStudyStatistics();
    },
    methods: {
      redirectToEnrollment() {
        this.$router.push({
          name: this.isEnrollmentOversight ? 'oversight-site-enrollment' : 'site-enrollment',
        });
      },
      async getStudyStatistics() {
        this.enrollmentData = [];
        try {
          this.loading = true;
          let response = await axios.get(`/api/get-study-statistics/${this.studyId}`);
          if (response.status !== 204) {
            let site = response.data['data']['sites'].find(
              element => element['siteInfo']['siteNumber'] === this.siteId,
            );
            if (site !== undefined) {
              this.enrollmentData.push({
                idx: 0,
                label: 'Study Randomized Number of Participants',
                randomized: response.data['data']['total']['enrollmentData']['randomized'],
                target: response.data['data']['studyGoal'],
              });
              this.enrollmentData.push({
                idx: 1,
                label: 'Site Current Randomized Number of Participants',
                randomized: site['enrollmentData']['randomized'],
                target: '-',
              });
              if (this.enrollmentData.length > 0) {
                this.value = response.data['data']['total']['enrollmentData']['randomized'];
                this.max = response.data['data']['studyGoal'];
              }
              this.showStudyEnrollment = true;
            }
          }
        } catch (error) {
          console.error(error);
        }
        this.loading = false;
      },
    },
  };
</script>

<style scoped>
  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #0060aa;
  }

  .textStyle {
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: #6f6f6f;
  }

  .progressBarInfo {
    padding-top: 1rem;
    padding-right: 0.5rem;
    text-align: right;
    width: 100%;
  }
  .info-number-style {
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;
  }
  .noDataTextStyle {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.5px;
    color: #383838;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
